var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{staticClass:"flex column page-layout",staticStyle:{"padding":"0"}},[_c('AllGames')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }